import axios from "../utils/axios";

class TicketInventoryReport
 {
    ticketInventoryReport (params)
    {
        return axios.get("ticketInventoryReport", {params})
    }

    ticketInventoryReportALL(params)
    {
        return axios.get("ticketInventoryReport/ALL", {params})
    }
    lists(params, getAssignedToUsers){
        return axios.get("tickets/"+(getAssignedToUsers || ''), {params});
    }
    lists1(params, getAssignedToUsers){
        return axios.get("tickets1/"+(getAssignedToUsers || ''), {params});
    }
    lists11(params, getAssignedToUsers){
        return axios.get("tickets11/"+(getAssignedToUsers || ''), {params});
    }
    lists113(params, getAssignedToUsers){
        return axios.get("tickets113/"+(getAssignedToUsers || ''), {params});
    }lists1131(params, getAssignedToUsers){
        return axios.get("tickets1131/"+(getAssignedToUsers || ''), {params});
    }
    lists2(params, getAssignedToUsers){
        return axios.get("tickets2/"+(getAssignedToUsers || ''), {params});
    }
    lists3(params, getAssignedToUsers){
        return axios.get("tickets3/"+(getAssignedToUsers || ''), {params});
    
    }
    lists5(params, getAssignedToUsers){
        return axios.get("tickets5/"+(getAssignedToUsers || ''), {params});
    
    }
}

export default new TicketInventoryReport();